import React from 'react'

const GuideforEditors = () => {
  return (
    <div>
      <p>
        Editors play a crucial role in maintaining the <b>scholarly integrity, quality, and credibility</b> of the journal. Their responsibilities include:
      </p>

      <br />
      <h4 className="fw-bold text-blue font-size-21">Manuscript Assessment</h4>
      <ul>
        <li>Conduct an initial <b>quality check</b> to ensure manuscripts meet submission standards.</li>
        <li>Evaluate the manuscript’s <b>relevance, originality, and ethical compliance</b>.</li>
        <li>Reject submissions that do not meet the journal’s scope or formatting requirements.</li>
      </ul>

      <br />
      <h4 className="fw-bold text-blue font-size-21">Peer-Review Management</h4>
      <ul>
        <li>Assign <b>qualified reviewers</b> based on subject expertise.</li>
        <li>Ensure a <b>double-blind peer review process</b> to maintain fairness.</li>
        <li>Oversee reviewer feedback and guide authors on necessary revisions.</li>
      </ul>

      <br />
      <h4 className="fw-bold text-blue font-size-21">Decision Making</h4>
      <ul>
        <li>Make the final decision on acceptance, revision, or rejection of manuscripts.</li>
        <li>Ensure decisions are based on scholarly merit and reviewer evaluations.</li>
        <li>Communicate decisions clearly and promptly to authors.</li>
      </ul>

      <br />
      <h4 className="fw-bold text-blue font-size-21">Ethical Responsibilities</h4>
      <ul>
        <li>Maintain confidentiality of all submitted manuscripts.</li>
        <li>Prevent conflicts of interest in manuscript handling.</li>
        <li>Uphold the <b>COPE (Committee on Publication Ethics)</b> guidelines.</li>
      </ul>

      <p>
        Editors ensure a transparent, fair, and ethical publication process that aligns with international academic standards.
      </p>
    </div>
  )
}

export default GuideforEditors
